import styled from 'styled-components';

import { colors } from '@/utils/constants';

interface AddressSuggestionsProps {
  showSuggestions: boolean;
}

export const AddressInputWrapper = styled.div`
  position: relative;

  // This is part of our browser autofill detection, which is required
  // because autofill does not, by itself, necessarily trigger any of
  // the events we watch to perform secondary actions, e.g. matching
  // targets to an advocate's address.
  @keyframes onAutoFillStart {
    from { opacity: 0.99; }
    to { opacity: 1; }
  }

  // Part of the autofill detection.
  input:-webkit-autofill {
    animation-name: onAutoFillStart;
    animation-duration: 0.001s;
  }
`;

export const AddressSuggestions = styled.ul<AddressSuggestionsProps>`
  position: absolute;
  z-index: 100;
  display: ${props => (props.showSuggestions ? 'block' : 'none')};
  width: 100%;
  box-shadow: 0 6px 12px rgb(0 0 0 / 8%);
  border: 1px solid rgb(24 24 24 / 10%);
  border-radius: 5px;
  background-color: ${colors.white};
`;

export const AddressSuggestion = styled.li`
  padding: 10px 16px;
  color: rgb(24 24 24 / 60%);
  font-size: 16px;
  line-height: 28px;
  cursor: pointer;

  &:hover {
    background-color: rgb(41 121 255 / 20%);
  }
`;
